import { FC } from "react";
import { Pragraph } from "../Pragraph/Pragraph";

export const ForthSection: FC = () => {
  return (
    <li>
      <div>4. 安全管理措置</div>
      <Pragraph>
        当社は、その取り扱う個⼈情報の漏えい、滅失⼜は毀損の防⽌その他個⼈情報の安全管理のために、必要かつ適切な措置を講じます。当社が講じる安全管理措置については、「5.お問合せ窓⼝」までお問合せください。
      </Pragraph>
    </li>
  );
};
